import React from 'react';
import { IconBaseProps } from 'react-icons';
import * as FaIcons from 'react-icons/fa';
import * as MdIcons from 'react-icons/md';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    size?: string | number;
    color?: string;
}

const FaChevronRight =  FaIcons['FaChevronRight'] as React.ComponentType<IconProps>;
const FaChevronLeft =  FaIcons['FaChevronLeft'] as React.ComponentType<IconProps>;
const FaCheck =  FaIcons['FaCheck'] as React.ComponentType<IconProps>;
const FaInfoCircle =  FaIcons['FaInfoCircle'] as React.ComponentType<IconProps>;
const FaExpandAlt =  FaIcons['FaExpandAlt'] as React.ComponentType<IconProps>;
const FaSun =  FaIcons['FaSun'] as React.ComponentType<IconProps>;
const FaMoon =  FaIcons['FaMoon'] as React.ComponentType<IconProps>;
const FaCompressAlt =  FaIcons['FaCompressAlt'] as React.ComponentType<IconProps>;
const FaRegEye =  FaIcons['FaRegEye'] as React.ComponentType<IconProps>;
const FaRegHeart =  FaIcons['FaRegHeart'] as React.ComponentType<IconProps>;
const FaHeart =  FaIcons['FaHeart'] as React.ComponentType<IconProps>;
const FaRegSmile =  FaIcons['FaRegSmile'] as React.ComponentType<IconProps>;
const FaBars =  FaIcons['FaBars'] as React.ComponentType<IconProps>;
const FaTimes =  FaIcons['FaTimes'] as React.ComponentType<IconProps>;
const MdVerified =  MdIcons['MdVerified'] as React.ComponentType<IconProps>;
const MdWork = MdIcons['MdWork'] as React.ComponentType<IconProps>; // Added
const MdLocationCity = MdIcons['MdLocationCity'] as React.ComponentType<IconProps>; // Added
const MdEmail = MdIcons['MdEmail'] as React.ComponentType<IconProps>; // Added
const MdPhone = MdIcons['MdPhone'] as React.ComponentType<IconProps>; // Added


const FaSearch = FaIcons['FaSearch'] as React.ComponentType<IconProps>;
const FaArrowLeft = FaIcons['FaArrowLeft'] as React.ComponentType<IconProps>;

const VisibilityIcon = MdIcons['MdVisibility'] as React.ComponentType<IconProps>;
const SentimentSatisfiedIcon = MdIcons['MdSentimentSatisfiedAlt'] as React.ComponentType<IconProps>;
const FavoriteIconReact = MdIcons['MdFavorite'] as React.ComponentType<IconProps>;
const FavoriteBorderIconReact = MdIcons['MdFavoriteBorder'] as React.ComponentType<IconProps>;

export {
    FaChevronRight,
    FaChevronLeft,
    FaCheck,
    FaInfoCircle,
    FaExpandAlt,
    FaSun,
    FaMoon,
    FaCompressAlt,
    FaRegEye,
    FaRegHeart,
    FaHeart,
    FaRegSmile,
    FaBars,
    FaTimes,
    MdVerified,
    MdWork, // Added
    MdLocationCity, // Added
    MdEmail, // Added
    MdPhone, // Added
    VisibilityIcon,
    SentimentSatisfiedIcon,
    FavoriteIconReact,
    FavoriteBorderIconReact,
    FaSearch, 
    FaArrowLeft, 
};

export type TimeSpecificIconComponent = React.ComponentType<IconProps>;

export interface CustomIconProps extends IconBaseProps {}
